const PRIVACY_MAIN = "https://anavio.ai/main-services-agreement";
const PRIVACY_BIO = "https://anavio.ai/biometric-privacy-consent";
const HELP_PAGE = "https://help.anavio.ai/";
const TimeToCloseWebRTCConnection = 60000;
const Data = {
  PRIVACY_MAIN,
  PRIVACY_BIO,
  TimeToCloseWebRTCConnection,
  HELP_PAGE,
};
export default Data;
